import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { InlineSpinner } from "components/Spinner";
import { findArrayIndex } from "util/dashboardManagement";

function renderAvailableBrandCategories(availableBrands, dashboardBrands, setDashboardBrands, dashboardAccounts, setDashboardAccounts) {
    return availableBrands.map(brand => {
        if (brand.accounts?.length > 0) {
            const brandChecked = (findArrayIndex(dashboardBrands, brand.name) > -1);
            return (
                <div key={brand.name}>
                    <details>
                        <summary>
                            <input
                                id={`brand-${brand.name}`}
                                type="checkbox"
                                name={brand.name}
                                value={brand.name}
                                onChange={e => handleOnChange(e, dashboardBrands, setDashboardBrands)}
                                checked={brandChecked}
                            />
                            <label htmlFor={`brand-${brand.name}`}>{brand.name}</label>
                        </summary>
                        <p>{brandChecked ? renderDisabledAccountsCheckboxList(brand) : renderAvailableAccountsCheckboxList(brand, dashboardAccounts, setDashboardAccounts)}</p>
                    </details>
                </div>
            )
        }
    })
}

function renderDisabledAccountsCheckboxList(brand) {
    return brand.accounts?.map(account => {
        return (
            <span key={account.id} style={{ marginLeft: 30 }}>
                <label htmlFor={`account-${account.name}`}>
                    <input
                        id={`account-${account.id}`}
                        type="checkbox"
                        name={account.name}
                        value={account.id}
                        checked
                        disabled
                    />
                    {account.name}
                </label>
                <br />
            </span>
        )
    })
}

function renderAvailableAccountsCheckboxList(brand, dashboardAccounts, setDashboardAccounts) {
    return brand.accounts?.map(account => {
        return (
            <span key={account.id} style={{ marginLeft: 30 }}>
                <label htmlFor={`account-${account.name}`}>
                    <input
                        id={`account-${account.id}`}
                        type="checkbox"
                        name={account.name}
                        value={account.id}
                        onChange={e => handleOnChange(e, dashboardAccounts, setDashboardAccounts)}
                        checked={findArrayIndex(dashboardAccounts, account.id) > -1}
                    />
                    {account.name}
                </label>
                <br />
            </span>
        )
    })
}

function renderSharedBrands(sharedBrands, dashboardBrands, setDashboardBrands) {
    return sharedBrands.map(brand => {
        return (
            <span key={brand}>
                <label htmlFor={`brand-${brand}`}>
                    <input
                        id={`brand-${brand}`}
                        type="checkbox"
                        name={brand}
                        value={brand}
                        onChange={e => handleOnChange(e, dashboardBrands, setDashboardBrands)}
                        checked={findArrayIndex(dashboardBrands, brand) > -1}
                    />
                    {brand}
                </label>
                <br />
            </span>
        )
    })
}

function renderSharedAccounts(sharedAccounts, availableAccounts, dashboardAccounts, setDashboardAccounts) {
    const availableAccountsMap = availableAccounts.reduce((map, account) => {
        map[account.id] = account;
        return map;
    }, {});

    const sharedAccountsWithBrands = sharedAccounts
        .map(account => {
            const availableAccount = availableAccountsMap[account.uuid];
            return availableAccount ? { ...account, brand: availableAccount.brand } : null;
        })
        .filter(Boolean);

    return sharedAccountsWithBrands.map(account => (
        <span key={account.uuid}>
            <label htmlFor={`account-${account.name}`}>
                <input
                    id={`account-${account.id}`}
                    type="checkbox"
                    name={account.name}
                    value={account.uuid}
                    onChange={e => handleOnChange(e, dashboardAccounts, setDashboardAccounts)}
                    checked={findArrayIndex(dashboardAccounts, account.uuid) > -1}
                />
                {account.name} ({account.brand})
            </label>
            <br />
        </span>
    ))
}

const handleOnChange = (e, currentPermissionSet, setPermissionSet) => {
    const newItem = e.target.value;
    const permissionSetCopy = [...currentPermissionSet];
    const index = findArrayIndex(permissionSetCopy, newItem);

    if (index > -1) {
        // if brand/account has already been selected to be shared, remove it
        permissionSetCopy.splice(index, 1);
        setPermissionSet([...permissionSetCopy]);
    } else {
        // if brand/account has not been selected to be shared until now, add it
        permissionSetCopy.push(newItem);
        setPermissionSet([...permissionSetCopy]);
    }
};

export function DashboardPermissioning({
    availableBrands,
    availableAccounts,
    sharedBrands = [],
    sharedAccounts = [],
    dashboardBrands,
    setDashboardBrands,
    dashboardAccounts,
    setDashboardAccounts
}) {

    useEffect(() => {
        if (sharedBrands.length > 0) {
            setDashboardBrands([...sharedBrands]);
        }
        if (sharedAccounts.length > 0) {
            setDashboardAccounts([...sharedAccounts.map(account => account.uuid)]);
        }
    }, [sharedBrands, sharedAccounts, setDashboardBrands, setDashboardAccounts]);

    return (
        <div className="container justify-content-center" style={{ display: 'grid' }}>
            <h5 className="row">Select Brands and Accounts the user can share Dashboards to</h5>
            <div className="row">
                <div className="col-md border p-2 ml-2" style={{ maxHeight: '25rem', overflow: 'auto' }}>
                    <b>Available Brands and Accounts:</b><br />
                    <span>{availableBrands.length > 0
                        ? renderAvailableBrandCategories(availableBrands, dashboardBrands, setDashboardBrands, dashboardAccounts, setDashboardAccounts)
                        : <InlineSpinner />}
                    </span>
                </div>
                <div className="col-md border p-2 ml-2" style={{ maxHeight: '25rem', overflow: 'auto' }}>
                    <b>Currently Shared With:</b><br />
                    <u>Brands</u><br />
                    <span>{sharedBrands.length > 0
                        ? renderSharedBrands(sharedBrands, dashboardBrands, setDashboardBrands)
                        : "Not currently shareable to any brands"}
                    </span>
                    <br /><u>Accounts</u><br />
                    <span>{sharedAccounts.length > 0
                        ? renderSharedAccounts(sharedAccounts, availableAccounts, dashboardAccounts, setDashboardAccounts)
                        : "Not currently shareable to any accounts"}
                    </span>
                </div>
            </div>
        </div>
    )
}